exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports
exports.locals = {
	"color-primary": "#D22338",
	"color-secondary": "#034A80",
	"color-tertiary": "#000",
	"color-success": "#468438",
	"color-info": "#51DDE9",
	"color-warning": "#F8B416",
	"color-danger": "#D22338",
	"color-light": "#f8f9fa",
	"color-dark": "#343a40",
	"collapse-transitionTime": ".3",
	"collapse-hiddenClass": "h-collapse",
	"collapse-transitioningClass": "h-collapsing",
	"collapse-shownClass": "h-show",
	"panel-transitionTime": ".15",
	"panel-hiddenClass": "h-panel-out",
	"panel-transitioningClass": "h-panel-transitioning",
	"panel-shownClass": "h-panel-in",
	"breakpoint-sm": "576px",
	"breakpoint-md": "768px",
	"breakpoint-lg": "992px",
	"breakpoint-xl": "1200px"
};